import { render, staticRenderFns } from "./FileShareAddBatchModifyAuth.vue?vue&type=template&id=db3f4e34&scoped=true"
import script from "./FileShareAddBatchModifyAuth.vue?vue&type=script&lang=js"
export * from "./FileShareAddBatchModifyAuth.vue?vue&type=script&lang=js"
import style0 from "./FileShareAddBatchModifyAuth.vue?vue&type=style&index=0&id=db3f4e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3f4e34",
  null
  
)

export default component.exports